const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Resolve a stored media path into a URL the browser can actually load.
 *
 * The storage API returns RELATIVE paths (/api/storage/public/...), which is
 * correct — storing an absolute URL would bake the hostname into the database
 * and break the moment the app moves. But a relative path resolves against the
 * PAGE origin, and in development the page is served by CRA on one port while
 * the API runs on another. The browser then asks the dev server for the image,
 * CRA answers every unknown path with index.html and a 200, and the <img>
 * silently fails with no error and no 404 to chase.
 *
 * That exact failure has now cost time twice: once on the site logo, once on
 * showcase screenshots. Anything rendering a stored media path goes through
 * here.
 *
 * In production REACT_APP_BACKEND_URL is empty and both share one origin, so
 * this returns the path unchanged.
 */
export const resolveMediaUrl = (path) => {
  if (!path) return path;
  // Already absolute, or a data/blob URL — leave it alone.
  if (/^(https?:)?\/\//i.test(path) || /^(data|blob):/i.test(path)) return path;
  if (!path.startsWith('/api/') || !API_URL) return path;

  try {
    return new URL(path, API_URL).href;
  } catch (e) {
    return path;
  }
};

export default resolveMediaUrl;
